module.exports = __webpack_public_path__ + "static/media/auto-file-segregation-tile.d857c811.svg";